import React from 'react'
import './about.css'


const About = () => {
  return (
    <div className="about">
      <h1>About This App</h1>
      <p>This app is all about Go Dubai app tours for react </p>
      <p>
        <strong>Version:2024</strong>
      </p>
    </div>
  );
}

export default About
